
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppHightlights from "@/components/settings-sales/Highlights.vue";
import { DossierConfigService } from "@/services";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";

export default Vue.extend({
	data(){
		return {
			settings: DossierConfigService.getSaleConfigs(),
			saving: false
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales", value: this.$ct("sale/purchase")
				},
				{
					value: this.$ct("sale-edit-highlights")
				}
			] as IBreadCrumb[];
		}
	},
	methods: {
		async save(){
			if (this.saving) return;
			this.saving = true;
			try{
				let settings = DossierConfigService.getSaleConfigs();
				settings.SaleEditHighlightSettings = this.settings.SaleEditHighlightSettings;
				this.settings = await DossierConfigService.setSaleConfigs(settings);
				this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
			}catch(err){

			}
			this.saving = false;
		}
	},
	components: {
		AppToolbar,
		AppHightlights,
		AppMobileFullScreenContainer,
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
